const getAvailableSectionNames = (expandedSectionRenderers, entity) => Object.entries(expandedSectionRenderers != null ? expandedSectionRenderers : {}).filter(([, { isAvailable }]) => {
  var _a;
  return (_a = isAvailable == null ? void 0 : isAvailable(entity)) != null ? _a : true;
}).map(([sectionName]) => sectionName);
export default getAvailableSectionNames;
